import React, { useEffect, useState } from "react";
import Images from "../../assets/images/index";
import Icons from "../../assets/icons/index";
import Modal from "react-bootstrap/Modal";
import { getAllShopList, getAllSubscriptionList } from "../../restApi/api";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import { decrypt } from "../../utils/crypto";
import { authorizationCheck } from "../../utils/logout";
import Loader from "../common/Loader/Loader";
export default function OrderDetail() {
  let { id } = useParams()
  let location = useLocation();
  let user = decrypt(localStorage.getItem('profileDetails'))
  user = JSON.parse(user)
  const [state, setStatus] = useState(JSON.parse(location.state));
  const [subscription, setSubscription] = useState(null);
  const [shops, setShop] = useState(null);
  const [show, setShow] = useState(false);
  let navigate = useNavigate()
  const [shopShow, setshopShow] = useState(false);
  let [loader, setloader] = useState(true)
  const detailShow = () => setShow(true);
  const detailHide = () => setShow(false);

  const shopdetailShow = () => setshopShow(true);
  const shopdetailHide = () => setshopShow(false);

  // const getallsubscriptionlist = async () => {
  //     await getAllSubscriptionList()
  //         .then(response => {
  //             return response.json()
  //         })
  //         .then(data => {
  // 	let req= JSON.parse(decrypt(data))
  //   if(req.data.code===1){
  // 		setSubscription(req)
  // 	}
  // 	else if(req.data.code==402){
  // 		authorizationCheck(navigate)
  // 	 }
  //         })
  // }


  // const getallshoplist = async () => {
  //     await getAllShopList()
  //         .then(response => {
  //             return response.json()
  //         })
  //       .then(data => {
  //           setloader(false)
  // 	let req= JSON.parse(decrypt(data))
  //   if(req.data.code===1){
  //     setShop(req)
  // 	}
  // 	else if(req.data.code==402){
  // 		authorizationCheck(navigate)
  // 	 }
  //       }).catch((error) => {
  //           setloader(false)
  //         })
  // }



  // let subscriptionDetail = []
  // let shopDetail = []
  // if (state === 'subscription') {
  //     subscription && subscription.data.result.packages.filter(obj => {
  //         if ((obj._id.toString()) === (id).toString()) {
  //             subscriptionDetail = obj
  //         }
  //     })
  // }
  // else if (state === 'shop') {
  //     shops && shops.data.result.packages.filter(obj => {
  //         if ((obj._id.toString()) === (id).toString()) {
  //             shopDetail = obj
  //         }
  //     })
  // }


  // useEffect(() => {
  //     getallsubscriptionlist()
  //     getallshoplist()
  // }, []);


  // console.log(state, "status");
  // console.log(subscriptionDetail, "subscriptionDetail");
  // console.log(shopDetail, "shopDetail");

  // const finalAmount = (data) => {    
  //   if (data?.isAssignedPackageByAdmin !== true) {
  //     if (data?.boughtWithVibe == true && data?.boughtWithNotes == false) {
  //       let paid_amount = data?.planPurchased?.discountPrice !== 0 ? data?.planPurchased?.discountPrice : data?.planPurchased?.mrp;
  //       let coupon_amount = data.couponDiscount ? data.couponDiscount : 0;
  //       // let pendrive_paid_amount = data.planPurchased&& data.planPurchased.vibe?.penDrivePaidAmount ? data.planPurchased.vibe?.penDrivePaidAmount : 0
  //       // let pendrive_coupon_amount = data.planPurchased&&data.planPurchased.vibe?.penDriveCouponDiscount ? data.planPurchased.vibe.penDriveCouponDiscount : 0;
  //       if (data?.planPurchased?.vibe !== null) {
  //         var pendrive_paid_amount = data?.planPurchased && data?.planPurchased?.vibe?.penDrivePaidAmount !== 0 ? data?.planPurchased?.vibe?.penDrivePaidAmount : 0
  //         var pendrive_coupon_amount = data?.planPurchased && data?.planPurchased?.vibe?.penDriveCouponDiscount ? data?.planPurchased?.vibe?.penDriveCouponDiscount : 0;
  //       }
  //       else {
  //         var pendrive_paid_amount = 0
  //         var pendrive_coupon_amount = 0
  //       }
  //       let final_amount = (paid_amount + pendrive_paid_amount) - (coupon_amount + pendrive_coupon_amount)
  //       return final_amount.toFixed(2);
  //     }
  //     else if (data?.boughtWithNotes == true && data?.boughtWithVibe == false) {
  //       let paid_amount = data?.planPurchased?.discountPrice !== 0 ? data?.planPurchased?.discountPrice : data?.planPurchased?.mrp;
  //       let coupon_amount = data.couponDiscount ? data.couponDiscount : 0;
  //       // let notes_paid_amount =data.planPurchased&& data.planPurchased.notes?.notesPaidAmount ? data.planPurchased.notes.notesPaidAmount : 0;
  //       // let notes_coupon_amount = data.planPurchased&& data.planPurchased.notes?.notesCouponDiscount ? data.planPurchased.notes.notesCouponDiscount : 0
  //       if (data?.planPurchased?.notes !== null) {
  //         var notes_paid_amount = data?.planPurchased && data?.planPurchased?.notes?.notesPaidAmount !== 0 ? data?.planPurchased?.notes?.notesPaidAmount : 0;
  //         var notes_coupon_amount = data?.planPurchased && data?.planPurchased?.notes?.notesCouponDiscount ? data?.planPurchased?.notes?.notesCouponDiscount : 0
  //       }
  //       else {
  //         var notes_paid_amount = 0
  //         var notes_coupon_amount = 0
  //       }
  //       let final_amount = (paid_amount + notes_paid_amount) - (coupon_amount + notes_coupon_amount)
  //       return final_amount.toFixed(2);
  //     }
  //     else if (data?.boughtWithNotes == false && data?.boughtWithVibe == false) {
  //       var paid_amount = 0
  //       var coupon_amount = 0
  //       if (data?.finalAmount) {
  //         paid_amount = data.finalAmount
  //       } else {
  //         paid_amount = data?.planPurchased?.discountPrice !== 0 ? data?.planPurchased?.discountPrice : data?.planPurchased?.mrp;
  //         console.log(paid_amount);
  //         coupon_amount = data.couponDiscount ? data.couponDiscount : 0;
  //       }
  //       if (data?.planPurchased?.notes !== null) {
  //         var notes_paid_amount = data?.planPurchased && data?.planPurchased?.notes?.notesPaidAmount !== 0 ? data?.planPurchased?.notes?.notesPaidAmount : 0;
  //         var notes_coupon_amount = data?.planPurchased && data?.planPurchased?.notes?.notesCouponDiscount ? data?.planPurchased?.notes?.notesCouponDiscount : 0
  //       }
  //       else {
  //         var notes_paid_amount = 0
  //         var notes_coupon_amount = 0
  //       }
  //       if (data?.planPurchased?.vibe !== null) {
  //         var pendrive_paid_amount = data?.planPurchased && data?.planPurchased?.vibe?.penDrivePaidAmount !== 0 ? data?.planPurchased?.vibe?.penDrivePaidAmount : 0
  //         var pendrive_coupon_amount = data?.planPurchased && data?.planPurchased?.vibe?.penDriveCouponDiscount ? data?.planPurchased?.vibe?.penDriveCouponDiscount : 0;
  //       }
  //       else {
  //         var pendrive_paid_amount = 0
  //         var pendrive_coupon_amount = 0
  //       }
  //       console.log(paid_amount, 'paid ammount');
  //       let final_amount = (paid_amount + notes_paid_amount + pendrive_paid_amount) - (coupon_amount + notes_coupon_amount + pendrive_coupon_amount)
  //       return final_amount.toFixed(2);
  //     }
  //     else {
  //       let paid_amount = data?.planPurchased?.discountPrice !== 0 ? data?.planPurchased?.discountPrice : data?.planPurchased?.mrp;
  //       let coupon_amount = data?.couponDiscount ? data?.couponDiscount : 0;
  //       if (data?.planPurchased?.notes !== null) {
  //         var notes_paid_amount = data?.planPurchased && data?.planPurchased?.notes?.notesPaidAmount !== 0 ? data?.planPurchased?.notes?.notesPaidAmount : 0;
  //         var notes_coupon_amount = data?.planPurchased && data?.planPurchased?.notes?.notesCouponDiscount != 0 ? data?.planPurchased?.notes?.notesCouponDiscount : 0
  //       }
  //       else {
  //         var notes_paid_amount = 0
  //         var notes_coupon_amount = 0
  //       }
  //       if (data?.planPurchased?.vibe !== null) {
  //         var pendrive_paid_amount = data?.planPurchased && data?.planPurchased?.vibe?.penDrivePaidAmount !== 0 ? data?.planPurchased?.vibe?.penDrivePaidAmount : 0
  //         var pendrive_coupon_amount = data?.planPurchased && data?.planPurchased?.vibe?.penDriveCouponDiscount != 0 ? data?.planPurchased?.vibe?.penDriveCouponDiscount : 0;
  //       }
  //       else {
  //         var pendrive_paid_amount = 0
  //         var pendrive_coupon_amount = 0
  //       }
  //       let final_amount = (paid_amount + notes_paid_amount + pendrive_paid_amount) - (coupon_amount)
  //       return final_amount.toFixed(2);
  //     }
  //   }
  //   else {
  //     let final_amount = 0
  //     return final_amount.toFixed(2);
  //   }
  // }
  function finalAmount(data) {
    if (data?.isAssignedPackageByAdmin !== true) {
      if (data?.boughtWithVibe === true && data?.boughtWithNotes === false) {
        let paid_amount = 0;
        let coupon_amount = 0;
        if (data.priceAfterCoupon) {
          paid_amount = data.priceAfterCoupon;
        } else {
          paid_amount = data?.planPurchased?.discountPrice !== 0 ? data?.planPurchased?.discountPrice : data?.planPurchased?.mrp;
          coupon_amount = data.couponDiscount ? data.couponDiscount : 0;
        }
        let pendrive_paid_amount = data?.planPurchased?.vibe !== null ? (data?.planPurchased?.vibe?.penDrivePaidAmount !== 0 ? data?.planPurchased?.vibe?.penDrivePaidAmount : 0) : 0;
        let pendrive_coupon_amount = data?.planPurchased?.vibe !== null ? (data?.planPurchased?.vibe?.penDriveCouponDiscount || 0) : 0;

        let final_amount = (paid_amount + pendrive_paid_amount) - (coupon_amount + pendrive_coupon_amount);
        return final_amount.toFixed(2);
      } else if (data?.boughtWithNotes === true && data?.boughtWithVibe === false) {
        let paid_amount = 0;
        let coupon_amount = 0;
        if (data.priceAfterCoupon) {
          paid_amount = data.priceAfterCoupon;
        } else {
          paid_amount = data?.planPurchased?.discountPrice !== 0 ? data?.planPurchased?.discountPrice : data?.planPurchased?.mrp;
          coupon_amount = data.couponDiscount ? data.couponDiscount : 0;
        }
        let notes_paid_amount = data?.planPurchased?.notes !== null ? (data?.planPurchased?.notes?.notesPaidAmount !== 0 ? data?.planPurchased?.notes?.notesPaidAmount : 0) : 0;
        let notes_coupon_amount = data?.planPurchased?.notes !== null ? (data?.planPurchased?.notes?.notesCouponDiscount || 0) : 0;

        let final_amount = (paid_amount + notes_paid_amount) - (coupon_amount + notes_coupon_amount);
        return final_amount.toFixed(2);
      } else if (data?.boughtWithNotes === false && data?.boughtWithVibe === false) {
        let paid_amount = 0;
        let coupon_amount = 0;
        if (data.priceAfterCoupon) {
          paid_amount = data.priceAfterCoupon;
        } else {
          paid_amount = data?.planPurchased?.discountPrice !== 0 ? data?.planPurchased?.discountPrice : data?.planPurchased?.mrp;
          coupon_amount = data.couponDiscount ? data.couponDiscount : 0;
        }
        let notes_paid_amount = data?.planPurchased?.notes !== null ? (data?.planPurchased?.notes?.notesPaidAmount !== 0 ? data?.planPurchased?.notes?.notesPaidAmount : 0) : 0;
        let notes_coupon_amount = data?.planPurchased?.notes !== null ? (data?.planPurchased?.notes?.notesCouponDiscount || 0) : 0;
        let pendrive_paid_amount = data?.planPurchased?.vibe !== null ? (data?.planPurchased?.vibe?.penDrivePaidAmount !== 0 ? data?.planPurchased?.vibe?.penDrivePaidAmount : 0) : 0;
        let pendrive_coupon_amount = data?.planPurchased?.vibe !== null ? (data?.planPurchased?.vibe?.penDriveCouponDiscount || 0) : 0;

        let final_amount = (paid_amount + notes_paid_amount + pendrive_paid_amount) - (coupon_amount + notes_coupon_amount + pendrive_coupon_amount);
        return final_amount.toFixed(2);
      } else {
        let paid_amount = 0;
        let coupon_amount = 0;
        if (data.priceAfterCoupon) {
          paid_amount = data.priceAfterCoupon;
        } else {
          paid_amount = data?.planPurchased?.discountPrice !== 0 ? data?.planPurchased?.discountPrice : data?.planPurchased?.mrp;
          coupon_amount = data?.couponDiscount ? data?.couponDiscount : 0;
        }
        let notes_paid_amount = data?.planPurchased?.notes !== null ? (data?.planPurchased?.notes?.notesPaidAmount !== 0 ? data?.planPurchased?.notes?.notesPaidAmount : 0) : 0;
        let notes_coupon_amount = data?.planPurchased?.notes !== null ? (data?.planPurchased?.notes?.notesCouponDiscount || 0) : 0;
        let pendrive_paid_amount = data?.planPurchased?.vibe !== null ? (data?.planPurchased?.vibe?.penDrivePaidAmount !== 0 ? data?.planPurchased?.vibe?.penDrivePaidAmount : 0) : 0;

        let final_amount = (paid_amount + notes_paid_amount + pendrive_paid_amount) - (coupon_amount);
        return final_amount.toFixed(2);
      }
    } else {
      return "0.00";
    }
  }

  const calculateAmount = (data) => {
    let finalAmount = 0;
    if (data?.purchaseType == 'SHOP') {
      let paid_amt = data?.finalAmount;
      let coin_discount = data?.coinUse;
      let coupon_amt = data?.couponDiscount;
      finalAmount = paid_amt - (coin_discount + coupon_amt)
      return finalAmount.toFixed(2)
    }
    //  else {
    //   let paid_amt = data?.paidAmount;
    //   let coin_discount = data?.coinUse;
    //   let coupon_amt = data?.couponAmount;
    //   let notes_paid_amt = data?.validity?.notes?.notesPaidAmount;
    //   let notes_coupon_amt = data?.validity?.notes?.notesCouponDiscount;
    //   finalAmount = (paid_amt + notes_paid_amt) - (coin_discount + coupon_amt + notes_coupon_amt)
    //   return finalAmount.toFixed(2)
    // }
  }

  const getSubscriptionPrice = (data, cond) => {
    let mrp = data?.planPurchased ? data?.planPurchased?.mrp : 0;
    let discount_price = data?.planPurchased ? data?.planPurchased?.discountPrice : 0;
    let coupon_amount = data?.couponDiscount;
    let final_amount = 0;
    var discounted_amount = mrp - discount_price;

    if (cond == 'sub_pack') {
      if (discount_price > 0) {
        final_amount = data.finalAmount ? data.finalAmount : (mrp - (discounted_amount + coupon_amount))
      } else {
        final_amount = mrp - coupon_amount
      }
      return final_amount.toFixed(2)
    } else if (cond == 'orgi_amo') {
      final_amount = mrp;
      return final_amount;
    } else if (cond == 'disc_amo') {
      if (data.priceAfterCoupon) {
        discounted_amount = mrp - data.priceAfterCoupon
        return discounted_amount.toFixed(2);
      } else {
        if (discount_price > 0) {
          discounted_amount = mrp - discount_price;
          final_amount = discounted_amount;
          return final_amount.toFixed(2);
        } else {
          final_amount = 0;
          return final_amount.toFixed(2)
        }
      }
    } else if (cond == 'coup_disc') {
      return coupon_amount;
    } else {
      return 0
    }

  }

  const getNotesAmount = (data, cond) => {
    let final_amount = 0;
    if (cond == 'note_amnt') {
      if (data?.planPurchased?.notes?.notesPurchasedWithSubscription == false) {
        let mrp = data?.planPurchased?.notes?.afterBuyNotesPrice;
        let discounted_price = mrp - (data.planPurchased?.notes?.afterBuyNotesDiscount)
        let coupon_amount = data.planPurchased?.notes?.notesCouponDiscount
        if ((data.planPurchased?.notes?.afterBuyNotesDiscount) > 0) {
          final_amount = mrp - (discounted_price + coupon_amount);
          return final_amount.toFixed(2)
        } else {
          final_amount = mrp - coupon_amount;
          return final_amount.toFixed(2)
        }

      } else {
        let mrp = data.planPurchased?.notes?.notesPrice;
        let discounted_price = mrp - (data.planPurchased?.notes?.notesDiscount)
        let coupon_amount = data.planPurchased?.notes?.notesCouponDiscount;

        if ((data.planPurchased?.notes?.notesDiscount) > 0) {
          final_amount = mrp - (discounted_price + coupon_amount);
          return final_amount.toFixed(2)
        } else {
          final_amount = mrp - coupon_amount;
          return final_amount.toFixed(2)
        }

      }
    } else if (cond == 'orig_amnt') {
      if (data?.planPurchased?.notes?.notesPurchasedWithSubscription == false) {
        final_amount = data.planPurchased?.notes?.afterBuyNotesPrice;
        return final_amount.toFixed(2);
      } else {
        final_amount = data.planPurchased?.notes?.notesPrice;
        return final_amount.toFixed(2);
      }
    } else if (cond == 'disc_amnt') {
      let mrp = 0;
      let discounted_price;
      if (data?.planPurchased?.notes?.notesPurchasedWithSubscription == false) {
        mrp = data?.planPurchased?.notes?.afterBuyNotesPrice;
        discounted_price = mrp - (data?.planPurchased?.notes?.afterBuyNotesDiscount);
        if ((data?.planPurchased?.notes?.afterBuyNotesDiscount) > 0) {
          final_amount = discounted_price;
          return final_amount.toFixed(2)
        } else {
          return final_amount = 0
        }
      } else {
        mrp = data.planPurchased?.notes?.notesPrice;
        discounted_price = mrp - data.planPurchased?.notes?.notesDiscount;
        if (data.planPurchased?.notes?.notesDiscount > 0) {
          final_amount = discounted_price;
          return final_amount.toFixed(2)
        } else {
          return final_amount = 0
        }

      }
      return 0;
    } else if (cond == 'coup_disc') {
      final_amount = data.planPurchased?.notes?.notesCouponDiscount
      return final_amount;

    } else {
      return final_amount = 0;
    }
  }

  const getPendriveAmount = (data, cond) => {
    let final_amount = 0;
    if (cond == 'pend_amnt') {
      if (data?.planPurchased?.vibe?.penDrivePurchasedWithSubscription == false) {
        let mrp = data?.planPurchased?.vibe?.afterBuyPendrivePrice;
        let discounted_price = mrp - (data?.planPurchased?.vibe?.afterBuyPendriveDiscount)
        let coupon_amount = data?.planPurchased?.vibe?.penDriveCouponDiscount
        if ((data.planPurchased?.vibe?.afterBuyPendriveDiscount) > 0) {
          final_amount = mrp - (discounted_price + coupon_amount);
          return final_amount.toFixed(2)
        } else {
          final_amount = mrp - coupon_amount;
          return final_amount.toFixed(2)
        }

      } else {
        let mrp = data.planPurchased?.vibe?.penDrivePrice;
        let discounted_price = mrp - (data.planPurchased?.vibe?.penDriveDiscount)
        let coupon_amount = data.planPurchased?.vibe?.penDriveCouponDiscount;

        if ((data.planPurchased?.vibe?.penDriveDiscount) > 0) {
          final_amount = mrp - (discounted_price + coupon_amount)
          return final_amount.toFixed(2)
        } else {
          final_amount = mrp - coupon_amount;
          return final_amount.toFixed(2)
        }

      }
    } else if (cond == 'orgn_amnt') {
      if (data?.planPurchased?.vibe?.penDrivePurchasedWithSubscription == false) {
        final_amount = data?.planPurchased?.vibe?.afterBuyPendrivePrice;
        return final_amount
      } else {
        final_amount = data?.planPurchased?.vibe?.penDrivePrice;
        return final_amount
      }
    } else if (cond == 'disc_amnt') {
      let mrp;
      let discounted_price;
      if (data?.planPurchased?.vibe?.penDrivePurchasedWithSubscription == false) {
        mrp = data.planPurchased?.vibe?.afterBuyPendrivePrice;
        discounted_price = mrp - (data.planPurchased?.vibe?.afterBuyPendriveDiscount);
        if (data.planPurchased?.vibe?.afterBuyPendriveDiscount !== 0) {
          final_amount = discounted_price;
          return final_amount
        } else {
          return final_amount = 0
        }
      } else {
        mrp = data.planPurchased?.vibe?.penDrivePrice;
        discounted_price = mrp - data.planPurchased?.vibe?.penDriveDiscount;

        if (data.planPurchased?.vibe?.penDriveDiscount !== 0) {
          return final_amount = discounted_price
        } else {
          return final_amount = 0
        }

      }
      // return 0;
    } else if (cond == 'copn_disc') {
      final_amount = data.planPurchased?.vibe?.penDriveCouponDiscount;
      return final_amount
    } else {
      return 0;
    }
  }
  //  const getNotesAmountForShop=(data)=>{
  //     console.log("data",data)
  //     let final_amt = 0;
  //     if(data.packageType == 3 ){
  //       let mrp = data?.validity?.notes?.notesPrice;
  //       let discounted_price = mrp - data?.validity?.notes?.notesDiscount;
  //       let coupon_dis_amt = data?.validity?.notes?.notesCouponDiscount;
  //       if(data?.validity?.notes?.notesDiscount){
  //         final_amt = mrp - (discounted_price+coupon_dis_amt);
  //         return final_amt;
  //       } else {
  //         final_amt = mrp - coupon_dis_amt;
  //         return final_amt
  //       }
  //     } else {
  //       let mrp = data?.validity?.mrp;
  //       let discounted_amt = mrp - data?.validity?.discountPrice;
  //       let coupon_amt = data?.couponAmount;
  //       if(data?.validity?.discountPrice > 0){
  //         final_amt = mrp - (discounted_amt + coupon_amt);
  //         return final_amt;
  //       } else {
  //         final_amt = mrp - coupon_amt;
  //         return final_amt;
  //       }
  //     }
  //   }

  const getAmountDetailsForNotes = (data, cond) => {
    let final_amt = 0;
    // for original Amount
    if (cond == 'original_amount') {
      final_amt = data?.planPurchased?.mrp;
      return final_amt;
    }

    // for discount amount
    if (cond == 'discount_amount') {
      let mrp = data?.planPurchased?.mrp;
      let discounted_amt = mrp - data?.planPurchased?.discountPrice;
      if (data?.planPurchased?.discountPrice > 0) {
        final_amt = discounted_amt;
        return final_amt;
      } else {
        return 0
      }
    }

    // coupon discount;
    if (cond == 'coupon_discount') {
      final_amt = data?.couponDiscount;
      return final_amt;
    } else {
      return 0
    }

  }

  //  const getPendriveAmountForShop=(data)=>{
  //     let final_amt = 0;
  //     let mrp = data?.validity?.mrp;
  //     let discount_amt = mrp - data?.validity?.discountPrice;
  //     let coupon_amt =data?.couponAmount;
  //     if(data?.validity?.discountPrice) {
  //       final_amt = mrp - (discount_amt + coupon_amt);
  //       return final_amt;
  //     } else {
  //       final_amt = mrp - coupon_amt;
  //       return final_amt;
  //     }
  //   }

  //  const getAmountDetailsForPendrive =(data,cond)=>{
  //     let final_amount = 0;

  //     if(cond == 'original_amount'){
  //       final_amount = data?.validity?.mrp;
  //       return final_amount;
  //     } else if(cond == 'discount_amount'){
  //       let mrp = data?.validity?.mrp;
  //       let discount_price = mrp - data?.validity?.discountPrice;
  //       let coupon_amt =data?.couponAmount;
  //       if(data?.validity?.discountPrice > 0){
  //         final_amount = mrp - (discount_price + coupon_amt) ;
  //         return final_amount;
  //       } else {
  //         final_amount = mrp - coupon_amt;
  //         return final_amount;
  //       }
  //     } else if(cond == 'coupon_discount') {
  //       final_amount = data?.couponAmount;
  //       return final_amount;
  //     } else {
  //       return final_amount
  //     }
  //   }

  const paidAmountForShop = (data) => {
    let final_amount = 0;
    let paid_amt = data?.finalAmount;
    let coupon_amount = data?.couponDiscount;
    // let notes_paid_amount = data?.planPurchased?.notes?.notesPaidAmount;
    // let notes_coupon_amount = data?.planPurchased?.notes?.notesCouponDiscount;
    // let vibe_paid_amount = data?.planPurchased?.vibe?.penDrivePaidAmount;
    // let vibe_coupon_amount = data?.planPurchased?.vibe?.penDriveCouponDiscount;
    if (data?.boughtWithNotes == false && data?.boughtWithVibe == false) {
      final_amount = paid_amt - coupon_amount;
      return final_amount;
    }
    // else if(data?.boughtWithNotes==true ) {
    // 	final_amount = (paid_amt + notes_paid_amount) - (coin_discount + coupon_amount + notes_coupon_amount);
    // 	return final_amount;
    // }
    //  else if() {
    //   final_amount = (paid_amt + notes_paid_amount) - (coin_discount + coupon_amount + notes_coupon_amount);
    //   return final_amount;
    // }
  }

  // if (loader) {
  //     return (<><Loader/></>)
  // }
  return (
    <>
      <div className="main_wrapper">
        <div className="breadcrumbs">
          <ul className="breadcrumb">
            <li className="breadcrumb-item"><a >Home</a></li>
            <li className="breadcrumb-item"><a >Account</a></li>
            <li className="breadcrumb-item"><a >My Order</a></li>
            <li className="breadcrumb-item active"><a >Order Details</a></li>
          </ul>
        </div>
        <section className="videoLayer_wrapper account_main_wrapper order_details_wrapper section_side_padding">
          <div className='row'>
            <div className="col-lg-8 col-md-7 col-sm-12">
              <div className="subjects_wrapper">
                <div className="setting_ttl_wrapper d-flex align-items-center">
                  <figure className="sett_back_arrow">
                    <Link to={'/account/myorder'}>
                      <img src={Icons.BackArrow} alt="" className="img-fluid" />
                    </Link>
                  </figure>
                  <div className="sett_ttl">
                    <h5>Order Details</h5>
                  </div>
                </div>
                {
                  state?.purchaseType === 'SUBSCRIPTION' &&
                  <div className="recommended_video_wrapper videoMainContent">
                    <div className="detailed_form">
                      <div className="form-group">
                        <label>order id</label>
                        {
                          state?.isAssignedPackageByAdmin === true && state?.expire === false &&
                          <p>Assigned</p>
                        }{
                          state?.isAssignedPackageByAdmin !== true &&
                          <p>{state ? state?.invoiceNumber : ''}</p>
                        }
                      </div>
                      <div className="form-group">
                        <label>purchased on</label>
                        <p>{state ? moment(state?.buyDate).format('DD MMM YYYY') : ""}, at {state ? moment(state?.buyDate).format('hh:mm a') : ""}</p>
                      </div>
                      {/* <div className="form-group">
                                        <label>valid till </label>
                                        <p>{state ? moment(state.tillDate).format('DD MMM YYYY') : ""}</p>
                                    </div> */}
                      <div className="form-group">
                        <label>status</label>
                        {/* {
                          state?.isAssignedPackageByAdmin === true && state?.expire === false &&
                          <p>Assigned</p>
                        } */}
                        {/* {
                                            (state.transactionStatus !== 'assigned' && state.transactionStatus === 'loan') &&
                                            <p>Loan Applied</p>
                                        } */}
                        {
                          state?.expire !== false &&
                          <p>Expired</p>
                        }
                        {
                          state?.status && state?.expire === false && state?.transactionStatus === 'COMPLETED' &&
                          <p>Active</p>

                        }
                        {
                          !state?.status && state?.expire === false && state?.transactionStatus === 'COMPLETED' &&
                          <p>Inactive</p>

                        }
                        {
                          state?.expire === false && (state?.transactionStatus === 'INITIATED' || state?.transactionStatus === 'PENDING') &&
                          <p>Initiated</p>

                        }
                        {
                          state?.expire === false && state?.transactionStatus === 'FAILED' &&
                          <p>Failed</p>

                        }
                      </div>
                      <div className="form-group">
                        <label>purchased plan</label>
                        <p>{state?.packageDetails && state?.packageDetails?.title}</p>
                        {/* <ul type="none"> */}
                        <div dangerouslySetInnerHTML={{ __html: `${state?.packageDetails ? state?.packageDetails?.description : ""}` }}></div>
                        {/* <li>292 Tests, 43 Grand test & 62 Subject wise tests attempted by 1Lakh students</li>
                                            <li>Questions curated by DBMCI/eGurukul faculties</li>
                                            <li>To the point explanation.</li>
                                            <li>Make your own Qbank with Custom Qbank module</li> */}
                        {/* </ul> */}
                      </div>
                      {
                        (state?.boughtWithNotes && state?.planPurchased?.notes != null || state?.boughtWithVibe && state?.planPurchased?.vibe != null) &&
                        <div className="form-group">


                          <label>Add-ons</label>

                          {
                            state?.boughtWithNotes && state?.planPurchased?.notes != null &&
                            <>
                              <p>Notes <span className="view_status_tag float-right" >View Status <img src={Icons.OrderDetailInfo} alt="" className="img-fluid" /></span></p>
                              <h6 ></h6>
                            </>
                          }
                          {
                            state?.boughtWithVibe && state?.planPurchased?.vibe != null &&
                            <>
                              <p>Vibe <span className="view_status_tag float-right" >View Status <img src={Icons.OrderDetailInfo} alt="" className="img-fluid" /></span></p>
                            </>
                          }
                        </div>
                      }
                      <div className="form-group">
                        <label>contact details</label>
                        <p><img src={Icons.Mail} alt="" className="img-fluid" /> {state?.userForAdmin?.email}</p>
                        <p><img src={Icons.Phone} alt="" className="img-fluid" /> {state?.userForAdmin?.mobileNo}</p>
                      </div>
                      <div className="form-group billing_address">
                        <label>billing address</label>
                        <p>{state?.billingAddress && state?.billingAddress?.fullAddress}</p>
                      </div>
                      {/* {
                                      (state.isAssignedPackageByAdmin !== true) &&
                                    <div className="form-group">
                                    <label>your loan request</label>
                                    <p>APPILED</p>
                                    </div>
                                    } */}
                      {
                        // state.isAssignedPackageByAdmin !== true &&
                        <div className="form-group border_zero">
                          <label>order summary</label>
                          <h6>&#8377; {finalAmount(state)} <span onClick={detailShow}>View Details <img src={Icons.OrderDetailInfo} alt="" className="img-fluid" /></span></h6>
                        </div>
                      }

                    </div>
                  </div>
                }
                {
                  state?.purchaseType === 'SHOP' &&
                  <div className="recommended_video_wrapper videoMainContent">
                    <div className="detailed_form">
                      <div className="form-group">
                        <label>order id</label>
                        <p>{state ? state?.invoiceNumber : ''}</p>
                      </div>
                      <div className="form-group">
                        <label>purchased on</label>
                        <p>{state ? moment(state?.buyDate).format('DD MMM YYYY') : ""}, at {state ? moment(state?.buyDate).format('hh:mm a') : ""}</p>
                      </div>
                      {/* <div className="form-group">
                                        <label>valid till</label>
                                        <p>{state ? moment(state.tillDate).format('DD MMM YYYY') : ""}</p>
                                    </div> */}
                      {/* {
                                      state.isFromMainSubscription==true&&
                                    <div className="form-group">
                                        <label>status</label>
                                          <p>As Add-On</p>
                                    </div>
                                    } */}
                      <div className="form-group">
                        <p>{state?.packageDetails ? state?.packageDetails?.title : ""}</p>
                        {/* <ul type="none"> */}
                        <div dangerouslySetInnerHTML={{ __html: `${state?.packageDetails ? state?.packageDetails?.description : ""}` }}></div>
                        {/* <li>292 Tests, 43 Grand test & 62 Subject wise tests attempted by 1Lakh students</li>
                                            <li>Questions curated by DBMCI/eGurukul faculties</li>
                                            <li>To the point explanation.</li>
                                            <li>Make your own Qbank with Custom Qbank module</li> */}
                        {/* </ul> */}
                      </div>
                      <div className="form-group">
                        <label>contact details</label>
                        <p><img src={Icons.Mail} alt="" className="img-fluid" /> {state?.userForAdmin?.email}</p>
                        <p><img src={Icons.Phone} alt="" className="img-fluid" /> {state?.userForAdmin?.mobileNo}</p>
                      </div>
                      <div className="form-group billing_address">
                        <label>billing address</label>
                        <p>{state.billingAddress && state.billingAddress.fullAddress}</p>
                      </div>
                      <div className="form-group">
                        <label>shipping address</label>
                        <p>{state.shippingAddress && state.shippingAddress.fullAddress}</p>
                      </div>
                      {
                        // state.isFromMainSubscription==false&&
                        <div className="form-group border_zero">
                          <label>order summary</label>
                          <h6>&#8377; {paidAmountForShop(state)} <span onClick={shopdetailShow}>View Details <img src={Icons.OrderDetailInfo} alt="" className="img-fluid" /></span></h6>
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </section>
      </div>
      <Modal
        show={show}
        onHide={detailHide}
        backdrop="static"
        className="detail_modal"
        centered
      >
        <Modal.Header>
          <Modal.Title>
            <h4>Order Summary</h4>
            <span className="cross_icon">
              <img src={Icons.ModalCross} alt="" className="img-fluid" onClick={detailHide} />
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="price_details">
            <div className="basic_plus d-flex align-items-center">
              <div className="main_ttl">
                <h6 className="text_blue"><p>{state?.packageDetails && state?.packageDetails.title}</p></h6>
              </div>
              <div className="price">
                <span className="price_blue">&#8377; {getSubscriptionPrice(state, 'sub_pack')}</span>
              </div>
            </div>
            <div className="basic_plus d-flex align-items-center">
              <div className="main_ttl">
                <h6>Original Amount</h6>
              </div>
              <div className="price">
                <span className="price_gray">&#8377; {getSubscriptionPrice(state, 'orgi_amo')}</span>
              </div>
            </div>
            <div className="basic_plus d-flex align-items-center">
              <div className="main_ttl">
                {/* <h6>Discounted Amount</h6> */}
                <h6>Discount</h6>
              </div>
              <div className="pricenew"> 
                <span>- &#8377; {getSubscriptionPrice(state, 'disc_amo')}</span>
              </div>
            </div>
            {/* <div className="basic_plus d-flex align-items-center">
              <div className="main_ttl">
                <h6>Coupon Amount</h6>
              </div>
              <div className="price">
                <span>- &#8377;{getSubscriptionPrice(state, 'coup_disc')}</span>
              </div>
            </div> */}
            {
              state?.boughtWithNotes && state?.planPurchased?.notes != null &&
              <>
                <div className="basic_plus d-flex align-items-center">
                  <div className="main_ttl">
                    <h6 className="text_blue"><p>Notes</p></h6>
                  </div>
                  <div className="price">
                    <span className="price_blue">&#8377; {getNotesAmount(state, 'note_amnt')}</span>
                  </div>
                </div>
                <div className="basic_plus d-flex align-items-center">
                  <div className="main_ttl">
                    <h6>Original Amount</h6>
                  </div>
                  <div className="price">
                    <span className="price_gray">&#8377; {getNotesAmount(state, 'orig_amnt')}</span>
                  </div>
                </div>
                <div className="basic_plus d-flex align-items-center">
                  <div className="main_ttl">
                    {/* <h6>Discounted Amount</h6> */}
                    <h6>Discount</h6>
                  </div>
                  <div className="pricenew">
                    <span>- &#8377; {getNotesAmount(state, 'disc_amnt')}</span>
                  </div>
                </div>
                {/* <div className="basic_plus d-flex align-items-center">
                  <div className="main_ttl">
                    <h6>Coupon Amount</h6>
                  </div>
                  <div className="price">
                    <span>- &#8377;{getNotesAmount(state, 'coup_disc')}</span>
                  </div>
                </div> */}
              </>
            }
            {
              state?.boughtWithVibe && state?.planPurchased?.vibe != null &&
              <>
                <div className="basic_plus d-flex align-items-center">
                  <div className="main_ttl">
                    <h6 className="text_blue"><p>Vibe</p></h6>
                  </div>
                  <div className="price">
                    <span className="price_blue">&#8377; {getPendriveAmount(state, 'pend_amnt')}</span>
                  </div>
                </div>
                <div className="basic_plus d-flex align-items-center">
                  <div className="main_ttl">
                    <h6>Original Amount</h6>
                  </div>
                  <div className="price">
                    <span className="price_gray">&#8377; {getPendriveAmount(state, 'orgn_amnt')}</span>
                  </div>
                </div>
                <div className="basic_plus d-flex align-items-center">
                  <div className="main_ttl">
                    <h6>Discounted Amount</h6>
                  </div>
                  <div className="price">
                    <span>- &#8377; {getPendriveAmount(state, 'disc_amnt')}</span>
                  </div>
                </div>
                <div className="basic_plus d-flex align-items-center">
                  <div className="main_ttl">
                    <h6>Coupon Amount</h6>
                  </div>
                  <div className="price">
                    <span>- &#8377;{getPendriveAmount(state, 'copn_disc')}</span>
                  </div>
                </div>
              </>
            }
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="price_details final_price">
            <div className="basic_plus d-flex align-items-center">
              {/* <div className="main_ttl">
                                <h6>Coin Discount</h6>
                            </div>
                            <div className="price">
                                <span className="price_gray">&#8377; {state?state.coinUse:0}</span>
                            </div> */}
            </div>
            <div className="basic_plus d-flex align-items-center">
              <div className="main_ttl">
                <h6 className="price_green">Total Amount</h6>
              </div>
              <div className="price">
                <span> &#8377; {finalAmount(state)} </span>
              </div>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      {/* // shop  */}
      {
        state.purchaseType == 'SHOP' &&
        <Modal
          show={shopShow}
          onHide={shopdetailHide}
          backdrop="static"
          className="detail_modal"
          centered
        >
          <Modal.Header>
            <Modal.Title>
              <h4>Order Summary</h4>
              <span className="cross_icon">
                <img src={Icons.ModalCross} alt="" className="img-fluid" onClick={shopdetailHide} />
              </span>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="price_details">
              <div className="basic_plus d-flex align-items-center">
                <div className="main_ttl">
                  <h6 className="text_blue"><p>Shop package</p></h6>
                </div>
                {
                  state.purchaseType == 'ADD-ON' &&
                  <div className="price">
                    <span className="price_blue">As Add-On</span>
                  </div>
                }
                {
                  state.purchaseType == 'SHOP' &&
                  <div className="price">
                    <span className="price_blue">&#8377; {calculateAmount(state)}</span>
                  </div>
                }
              </div>
              {
                <>
                  <div className="basic_plus d-flex align-items-center">
                    <div className="main_ttl">
                      <h6>Original Amount</h6>
                    </div>
                    <div className="price">
                      <span className="price_gray">&#8377; {getAmountDetailsForNotes(state, 'original_amount')}</span>
                    </div>
                  </div>
                  <div className="basic_plus d-flex align-items-center">
                    <div className="main_ttl">
                      <h6>Discounted Amount</h6>
                    </div>
                    <div className="price">
                      <span>- &#8377; {getAmountDetailsForNotes(state, 'discount_amount')}</span>
                    </div>
                  </div>
                  <div className="basic_plus d-flex align-items-center">
                    <div className="main_ttl">
                      <h6>Coupon Amount</h6>
                    </div>
                    <div className="price">
                      <span>- &#8377;{getAmountDetailsForNotes(state, 'coupon_discount')}</span>
                    </div>
                  </div>
                </>
              }

            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="price_details final_price">
              <div className="basic_plus d-flex align-items-center">
                {/* <div className="main_ttl">
                                <h6>Coin Discount</h6>
                            </div> */}
                {/* <div className="price">
                                <span className="price_gray">&#8377; {state?state.coinUse:0}</span>
                            </div> */}
              </div>
              <div className="basic_plus d-flex align-items-center">
                <div className="main_ttl">
                  <h6 className="price_green">Total Amount</h6>
                </div>
                <div className="price">
                  {
                    state.purchaseType == 'SHOP' &&
                    <span> &#8377; {paidAmountForShop(state)}</span>

                  }
                  {/* {
                                    shopDetail.purchaseType=='ADD-ON' &&
                                    <span> As Add-On</span>

                                } */}
                </div>
              </div>
            </div>
          </Modal.Footer>
        </Modal>
      }
    </>
  )
}